import { createSlice } from '@reduxjs/toolkit'

/**
 * Drafts Slice
 * Manages submission draft state including file upload tracking
 */
const draftsSlice = createSlice({
  name: 'drafts',
  initialState: {
    uploadsInProgress: {}, // { 'draft-123': ['pdf', 'xml', 'invoice'] }
    // Software the last submitted 3.6 ZIP named (e.g. 'TOTAL'); drives the Reggora Forms popup.
    // Kept here, not in the submit button, so the popup survives the order row re-rendering.
    formsSuggestionSoftware: null,
  },
  reducers: {
    startFileUpload: (state, action) => {
      const { draftId, fileType } = action.payload
      if (!state.uploadsInProgress[draftId]) {
        state.uploadsInProgress[draftId] = []
      }

      if (!state.uploadsInProgress[draftId].includes(fileType)) {
        state.uploadsInProgress[draftId].push(fileType)
      }
    },
    endFileUpload: (state, action) => {
      const { draftId, fileType } = action.payload
      const uploads = state.uploadsInProgress[draftId] || []
      const filtered = uploads.filter(type => type !== fileType)

      if (filtered.length === 0) {
        delete state.uploadsInProgress[draftId]
      } else {
        state.uploadsInProgress[draftId] = filtered
      }
    },
    showFormsSuggestion: (state, action) => {
      state.formsSuggestionSoftware = action.payload
    },
    hideFormsSuggestion: (state) => {
      state.formsSuggestionSoftware = null
    },
  },
})

export const { endFileUpload, hideFormsSuggestion, showFormsSuggestion, startFileUpload } = draftsSlice.actions
export default draftsSlice.reducer
